// lv-signup · Klaviyo signup for LV pages.
// Mirrors the live PDP capture logic (sections/v2-pdp-copy-2.liquid, 2026):
//   ipapi.co country lookup -> DE/AT/CH/LI = double opt-in list, all others = single opt-in list,
//   lookup failure = double opt-in (safer), Meta Pixel 'Lead' after success,
//   anything not on lumenaryvision.com is simulated and never subscribes.
const LV_DOI_COUNTRIES = ['DE', 'AT', 'CH', 'LI'];
const LV_LIVE_HOST = /(^|\.)lumenaryvision\.com$/i;

class LvSignup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.error = this.querySelector('.lv-form__error');
    this.form?.addEventListener('submit', (event) => this.submit(event));
  }

  async country() {
    try {
      const res = await fetch('https://ipapi.co/json/');
      const geo = await res.json();
      return (geo && geo.country_code) || '';
    } catch (err) {
      return '';
    }
  }

  async subscribe(email, listId, cc) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.company)}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.dataset.source,
            profile: { data: { type: 'profile', attributes: { email, properties: { source_page: this.dataset.page, detected_country: cc || 'unknown' } } } },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      }),
    });
    if (!res.ok && res.status !== 202) throw new Error(String(res.status));
  }

  success(isDoi) {
    const text = this.querySelector('[data-success-text]');
    if (text) text.textContent = isDoi ? this.dataset.successDoi : this.dataset.successSoi;
    this.classList.add('is-success');
    if (typeof window.fbq !== 'undefined') window.fbq('track', 'Lead');
  }

  async submit(event) {
    event.preventDefault();
    const email = this.form.email.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      this.error.textContent = this.error.dataset.error || 'Please check your email.';
      this.form.email.focus();
      return;
    }
    this.error.textContent = '';
    const button = this.form.querySelector('button');
    button.disabled = true;

    if (!LV_LIVE_HOST.test(location.hostname)) {
      setTimeout(() => this.success(false), 600);
      return;
    }
    try {
      const cc = await this.country();
      const isDoi = cc === '' ? true : LV_DOI_COUNTRIES.includes(cc);
      await this.subscribe(email, isDoi ? this.dataset.listDoi : this.dataset.listSoi, cc);
      this.success(isDoi);
    } catch (err) {
      this.error.textContent = 'Something went wrong. Please try again.';
      button.disabled = false;
    }
  }
}

if (!customElements.get('lv-signup')) customElements.define('lv-signup', LvSignup);
